import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

interface ChatSearchProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
}

export function ChatSearch({ searchQuery, onSearchChange }: ChatSearchProps) {
  return (
    <div className="flex items-center gap-2">
      <Search className="h-4 w-4 text-muted-foreground" />
      <Input
        placeholder="Søk i lagrede chatter..."
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        className="flex-1"
      />
    </div>
  );
}